import React from 'react'
import './skills.css'
import {motion} from 'framer-motion/dist/framer-motion'
import {options} from '../../Components/options'

function Skills() {
    return (
        <motion.div 
        initial={options.initial}
        animate={options.animate}
        exit={options.exit}
        className="row_1_pages skillContainer"
        >
            <div className="col_1_pages">
                    <h2>Skills</h2>
                    <p>&nbsp; My studies at South Texas College. Pursueing the 
                        Bachelors for Computer Information Technologies. Have exposed me to 
                        many technologies. From <span className="tag">Assembly</span> to <span className="tag">python</span> i have worked with <span className="tag">node.js</span>, <span className="tag">Html</span>, <span className="tag">Css</span>, <span className="tag">Javascript</span>, Front/Backend frameworks. as well as <span className="tag">java</span>,<span className="tag"> mysql</span>,
                        along with NOSQL database technologies <span className="tag">mangoDB</span> 
                        <br/><br/> 
                        With my skills and experiences from the exposure to these technologies. I am very confident on my abilities to provide Technical solutiuons 
                        as well as being a great asset to the team. By contributing to the project while adding a great dynamic enviroment with my personality. 
                        <br/> <br/> 
                        I have a associates degree in Computer Science, Alonbg with a bachelors in CIT ( Computer Information Technologies ). As such i have taken classes
                        for Network security, network technologies, algorigthms and data structures. Of course working with many technologies. I have gained an insight into the 
                        developement patterns, data structures and Critical thinking skills needed in this profession. 
                        <br/> <br/> 
                        i have been exposed to Application technologies such as <span className="tag">Java </span>, <span className="tag">C# </span>,
                        <span className="tag">C++ </span>, <span className="tag">C </span>, 
                    </p>
            </div>

            <div className="col_1_pages right_skills">
                <div className="col_2_wrapper">
                    <span>Front-End</span>
                    <div className="skillContainer__right__container__outer">
                        <div className="skillContainer__right__container__inner front-end">
                            
                        </div>
                    </div>
                    <span>Back-End</span>
                    <div className="skillContainer__right__container__outer">
                        <div className="skillContainer__right__container__inner back-end">

                        </div>
                    </div>
                    <span>React.js</span>
                    <div className="skillContainer__right__container__outer">
                        <div className="skillContainer__right__container__inner react">

                        </div>
                    </div>

                    <span>Node.js</span>
                    <div className="skillContainer__right__container__outer">
                        <div className="skillContainer__right__container__inner node">

                        </div>
                    </div>
                </div>


            </div>
        </motion.div>
    )
}

export default Skills
